module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAFCAYAAACeuGYRAAAAf0lEQVQYlWNmYGBg+P//P+Nxkw+lqlHWAneWH7/NQAAw+m0s4/3B+DOWgZHxFTPz382ENHznFP7L8oPxTx4jE5Ml499/K/4xsMb9//+fEacN/xmYOP98vM7C8Z9l0o9/P9//Z2L8wcz8ezUxNjHA/OS2Ob/UY3ORFyFNDAwMDADkcTETz/syZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/arrow_back_1x.png
// module id = 2279
// module chunks = 0